import React, { useRef, useState } from "react";
//import DataTable from "react-data-table-component";
import Input from "components/Elements/Input";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import {
  updateSupportingContentItem,
  updateSupportingContentItemStatus,
} from "services/supportingContent";

DataTable.use(DT);

const EditAffirmationModal = NiceModal.create(
  ({ row, title = "Affirmations" }) => {
    const [savingAffirmation, setSavingAffirmation] = useState(false);

    const item = row.data();
    const el = document.createElement("div");
    el.innerHTML = item[3];
    const affirmationText = el.innerText;
    const [affirmation, setAffirmation] = useState(affirmationText);

    const formRef = useRef(null);
    const modal = useModal();

    const hide = (e) => {
      modal.remove();
    };

    const save = async (e) => {
      // Save into the table
      const newDataRow = row.data();
      newDataRow[3] = `<div style="font-weight: 700">${affirmation}</div>`;
      row.data(newDataRow).draw();

      setSavingAffirmation(true);
      const response = await updateSupportingContentItem(item[0], {
        data: affirmation,
      });
      console.log("!!! RESPONSE: ", response);
      setSavingAffirmation(false);
      modal.remove();
    };

    const handleChange = (e) => {
      console.log("CHANGE: ", e.target.value);
      setAffirmation(e.target.value);
    };

    return (
      <>
        <div className="w-5/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-hidden overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative w-full my-6 mx-auto max-w-3xl">
            {/*content*/}
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              {/*header*/}
              <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                <h3 className="text-3xl font-semibold">Edit {title}</h3>
                <button
                  className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={hide}
                >
                  <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
              </div>
              {/*body*/}
              <div className="relative p-6 flex-auto ">
                <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                  <form ref={formRef}>
                    <label>{title}</label>
                    <Input
                      label="Affirmation"
                      type="textarea"
                      placeholder="Affirmation"
                      name="affirmation"
                      value={affirmation}
                      onChange={handleChange}
                      style={{ height: "200px" }}
                    />
                  </form>
                </div>
              </div>
              <div className="relative p-6 flex-auto"></div>
              {/*footer*/}
              <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                {!savingAffirmation ? (
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={hide}
                  >
                    Close
                  </button>
                ) : null}
                <button
                  className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={save}
                  disabled={savingAffirmation}
                >
                  {savingAffirmation ? (
                    <>
                      <i className="fas fa-circle-notch fa-spin"></i>{" "}
                      Processing...
                    </>
                  ) : (
                    <>Save</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    );
  }
);

NiceModal.register("edit-affirmation-item", EditAffirmationModal);

const AffirmationsTable = ({ affirmations, content_title = "Affirmation" }) => {
  const tableRef = useRef(null);

  const findRowById = (id) => {
    if (tableRef.current) {
      const table = tableRef.current.dt();
      const row = table.row((idx, data) => data[0] === id);
      return row;
    }
  };

  const progressCircle = `<div style="width: 10px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 50 50">
  <circle cx="25" cy="25" r="20" fill="none" stroke="#555" stroke-width="5" stroke-dasharray="31.4 31.4" stroke-linecap="round">
    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.8s" keyTimes="0;1" values="0 25 25;360 25 25"/>
  </circle>
</svg></div>
`;

  window.approve = async (id) => {
    const approveButton = document.getElementById(`approve-${id}`);
    approveButton.classList.add("disabled");
    approveButton.disabled = true;
    approveButton.innerHTML = progressCircle;

    const rejectButton = document.getElementById(`reject-${id}`);
    rejectButton.classList.add("disabled");
    rejectButton.disabled = true;

    const row = findRowById(id);
    const response = await updateSupportingContentItemStatus(id, "approve");
    if (response.success) {
      const newRowData = row.data();
      newRowData[5] = "approved";
      row.data(newRowData).draw();
    }
  };

  window.reject = async (id) => {
    const rejectButton = document.getElementById(`reject-${id}`);
    rejectButton.classList.add("disabled");
    rejectButton.disabled = true;
    rejectButton.innerHTML = progressCircle;

    const approveButton = document.getElementById(`approve-${id}`);
    approveButton.classList.add("disabled");
    approveButton.disabled = true;

    const row = findRowById(id);
    const response = await updateSupportingContentItemStatus(id, "reject");
    if (response.success) {
      const newRowData = row.data();
      newRowData[5] = "rejected";
      row.data(newRowData).draw();
    }
  };

  window.edit = (id) => {
    if (tableRef.current) {
      const table = tableRef.current.dt();
      const row = table.row((idx, data) => data[0] === id);

      NiceModal.show("edit-affirmation-item", {
        row: row,
        title: content_title,
      });
    }
  };

  const tableData = affirmations.map((affirmation) => {
    return [
      affirmation.public_id,
      affirmation.text_key.split(":")[0],
      affirmation.text_key.split(":")[1],
      `<div style="font-weight: 700">${affirmation.data}</div>`,
      affirmation.description,
      affirmation.status ?? "Not reviewed",
      `<div style="display: flex; flex-direction: row;"><button style="width: 60px;" id="approve-${affirmation.public_id}" onClick="approve('${affirmation.public_id}')" class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✓</button><button style="width: 60px;" id="reject-${affirmation.public_id}" onClick="reject('${affirmation.public_id}')" class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">×</button><button onClick="edit('${affirmation.public_id}')" class="bg-blueGray-500 text-white active:bg-blueGray-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✎</button></div>`,
    ];
  });

  return (
    <DataTable
      ref={tableRef}
      data={tableData}
      className="display"
      options={{
        responsive: true,
        select: true,
        pageLength: 25,
      }}
    >
      <thead>
        <tr>
          <th>ID</th>
          <th>Topic</th>
          <th>Goal</th>
          <th>{content_title}</th>
          <th>Reason</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
    </DataTable>
  );

  /*
  return (
    <DataTable
      title="Affirmations"
      columns={columns}
      data={data}
      pagination
      highlightOnHover
    />
  );
    */
};

export default AffirmationsTable;
